export function formatAssignmentDuration(duration, shortFormat = true) {
  if (!duration) return null;

  const hours = Math.floor(duration / 60);
  const minutes = duration % 60;
  if (shortFormat) {
    return hours ? `${hours}h ${minutes}m` : `${minutes}m`;
  }
  const hoursText = `${hours} ${hours === 1 ? 'hour' : 'hours'} `;
  const minutesText = `${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`;
  return `${hours ? hoursText : ''}${minutesText}`;
}
